export default __webpack_public_path__ + "static/media/english-round-image.69e18eb1.png";